module.exports = __webpack_public_path__ + "img/full5-min.4e81a3ec.png";